<template>
  <div class="business-classes">
    <common-layout>
      <div slot="header">
        <h3>课程期数</h3>
      </div>
      <div slot="container">
        <div class="business-classes.header">
          <el-button class="business-person.addBtn" @click="$router.go(-1)">返回上一页</el-button>
          <el-button
            type="success"
            icon="el-icon-plus"
            @click="add"
            style="background: #623AA2; border: none;"
          >
            新增
          </el-button>

          <section>
            <span style="margin-right: 10px">课程</span>
            <el-select v-model="value" placeholder="请选择课程级别" @change="search">
              <el-option
                v-for="item in [{ id: '', courseName: '全部' }].concat(options)"
                :key="item.id"
                :label="item.courseName"
                :value="item.id"
              ></el-option>
            </el-select>
            <span style="margin:0  0px 0 15px">状态</span>

            <el-select
              v-model="status"
              placeholder="请选择课程状态"
              @change="search"
              style="margin: 0 10px;"
            >
              <el-option label="全部" value></el-option>
              <el-option label="进行中" :value="1"></el-option>
              <el-option label="已结束" :value="2"></el-option>
              <el-option label="可报名" :value="3"></el-option>
              <el-option label="不可报名" :value="4"></el-option>
            </el-select>
            <label style="margin-right: 10px; line-height: 40px; min-width: 60px">发布平台:</label>
            <el-select
              style="width: 300px"
              v-model="srelease"
              clearable
              placeholder="请选择发布平台"
              @change="search"
            >
              <el-option label="双平台" :value="1" />
              <el-option label="大市场平台" :value="2" />
              <el-option label="成果交易平台" :value="3" />
            </el-select>
          </section>
        </div>
        <div class="business-classes.table">
          <el-table :data="tableData" stripe style="width: 100%" :header-cell-style="headerStyle">
            <el-table-column type="index" label="序号" align="center" width="90">
              <template slot-scope="scope">
                <span>{{ scope.$index + (current_page - 1) * per_page + 1 }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="courseName" label="课程级别" align="center"></el-table-column>
            <el-table-column prop="coursePhase" label="培训期数" align="center"></el-table-column>
            <el-table-column label="课程剪影" align="center">
              <template slot-scope="scope">
                <el-button type="primary" @click="goPhotoList(scope.row)">课程剪影</el-button>
              </template>
            </el-table-column>
            <el-table-column prop="courseStatus" label="状态" align="center">
              <template slot-scope="scope">
                <el-tag type="success" v-show="scope.row.courseStatus == 1">进行中</el-tag>
                <el-tag type="info" v-show="scope.row.courseStatus == 2">已结束</el-tag>
                <el-tag v-show="scope.row.courseStatus == 3">可报名</el-tag>
                <el-tag type="danger" v-show="scope.row.courseStatus == 4">不可报名</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="发布平台" align="center">
              <template slot-scope="scope">
                {{
                  scope.row.isAchievement === 1 && scope.row.isMarket === 1
                    ? '双平台'
                    : scope.row.isMarket === 1
                    ? '大市场平台'
                    : '成果交易平台'
                }}
              </template>
            </el-table-column>
            <el-table-column align="left" label="操作" width="180">
              <template slot-scope="scope">
                <el-button
                  class="mini_btn"
                  size="mini"
                  type="primary"
                  @click="handleEdit(scope.row)"
                >
                  编辑
                </el-button>
                <el-button
                  class="mini_btn"
                  size="mini"
                  type="danger"
                  v-show="scope.row.course_status == 4 || !scope.row.enroll_num"
                  @click="handleDelete(scope.row)"
                >
                  删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="pagination">
          <div class="grid-content bg-purple-light">
            <el-pagination
              @current-change="handleCurrentChange"
              layout="total, prev, pager, next,jumper"
              :total="total"
              :current-page.sync="current_page"
              :page-size="per_page"
            ></el-pagination>
          </div>
        </div>
      </div>
    </common-layout>
    <el-dialog
      title="课程期数详情"
      :visible.sync="dialogVis"
      width="30%"
      :close-on-click-modal="false"
      @closed="is_submit = true"
    >
      <el-form :model="form" :rules="rules" label-width="80px" ref="form">
        <el-form-item label="课程级别" prop="courseId">
          <el-select
            v-model="form.courseId"
            style="width: 100%;"
            　clearable
            :disabled="operate == 'edit'"
          >
            <el-option
              v-for="item in options"
              :key="item.id"
              :label="item.courseName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="培训期数" prop="coursePhase">
          <el-input
            v-model="form.coursePhase"
            placeholder="请填写培训期数"
            type="number"
            :disabled="operate == 'edit'"
          ></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="courseStatus">
          <el-select v-model="form.courseStatus" style="width: 100%;" 　clearable>
            <el-option label="进行中" :value="1"></el-option>
            <el-option label="已结束" :value="2"></el-option>
            <el-option label="可报名" :value="3"></el-option>
            <el-option label="不可报名" :value="4"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="同步发布" prop="isMarket" style="text-align: left">
          <el-select
            v-model="is_market"
            placeholder="请选择"
            style="width: 100%"
            @change="formmarket"
          >
            <el-option label="双平台" :value="1" />
            <el-option label="大市场平台" :value="2" />
            <el-option label="成果交易平台" :value="3" />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" @click="submitEvent">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import CommonLayout from '../../components/common-layout.vue';
export default {
  components: {
    CommonLayout,
  },
  data() {
    return {
      is_submit: true,
      operate: 'add',
      srelease: '',
      options: [
        {
          value: '',
          label: '全部',
        },
        {
          value: '初级',
          label: '初级',
        },
        {
          value: '中级',
          label: '中级',
        },
        {
          value: '高级',
          label: '高级',
        },
        {
          value: '选修',
          label: '选修',
        },
      ],
      value: '',
      status: '',
      headerStyle: {
        color: '#623AA2',
        background: '#E5F3FE',
      },
      total: 20,
      current_page: 1,
      per_page: 10,
      dialogVis: false,
      tableData: [
        { course_id: '张三', course_phase: '中级', course_status: '第一期' },
        { course_id: '张三', course_phase: '中级', course_status: '第一期' },
        { course_id: '张三', course_phase: '中级', course_status: '第一期' },
        { course_id: '张三', course_phase: '中级', course_status: '第一期' },
        { course_id: '张三', course_phase: '中级', course_status: '第一期' },
      ],
      is_market:1,
      form: {
        courseId: '',
        coursePhase: '',
        courseStatus: 4,
        isMarket: 1,
        isAchievement: 1,
      },
      rules: {
        courseId: [
          {
            required: true,
            message: '请选择课程级别',
            trigger: 'change',
          },
        ],
        coursePhase: [
          {
            required: true,
            message: '请输入课程期数',
            trigger: 'blur',
          },
        ],
        courseStatus: [
          {
            required: true,
            message: '请选择课程状态',
            trigger: 'blur',
          },
        ],
      },
    };
  },
  methods: {
    search() {
      this.current_page = 1;
      this.getData(
        'Technology_Skill_Course_Phase?course_id=' + this.value + '&course_status=' + this.status + (this.srelease ? (this.srelease === 1 ? "&is_market=1&is_achievement=1" : (this.srelease === 2 ? "&is_market=1&is_achievement=2" : "&is_market=2&is_achievement=1")) : '')
      );
    },
    formmarket(val) {
      if (val === 1) {
        this.form.isMarket = 1;
        this.form.isAchievement = 1;
      } else if (val === 2) {
        this.form.isMarket = 1;
        this.form.isAchievement = 2;
      } else {
        this.form.isMarket = 2;
        this.form.isAchievement = 1;
      }
    },
    goPhotoList(row) {
      if (row.courseStatus != 2) {
        this.$message.warning('只有已结束才能录制课程剪影');
      } else {
        this.$router.push({
          path: `/transfer/business/photo?id=${row.id}`,
        });
      }
    },
    add() {
      this.operate = 'add';
      this.is_market = 1
      this.dialogVis = true;
      this.$refs['form'].resetFields();
    },
    handleEdit(row) {
      this.operate = 'edit';
      this.dialogVis = true;
      this.form = Object.assign({}, row);
      this.is_market =
        this.form.isAchievement === 1 && this.form.isMarket === 1
          ? 1
          : this.form.isMarket === 1
          ? 2
          : 3;
    },
    handleDelete(row) {
      this.$confirm('此操作将永久删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true,
      })
        .then(() => {
          if (row.enroll_num) {
            this.$message.warning('当前课程已有人报名,禁止删除');
            return true;
          }

          this.http.request(`${urlConfig.devUrl}apij2/admin-api/voucher/technology-skill-course-phase/delete?id=` + row.id, '', 'delete').then(res => {
            if (res.code == 0) {
              this.ResetSearch(['value', 'status']);
              this.getData('Technology_Skill_Course_Phase?page=' + this.current_page);
              this.$message({
                type: 'success',
                message: '删除成功',
              });
            } else {
              this.$message({
                message: '失败！',
                type: 'error',
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          });
        });
    },
    submitEvent() {
      if (!this.is_submit) {
        return false;
      }
      this.is_submit = false;
      this.$refs['form'].validate(valid => {
        let obj = {
          courseId: this.form.courseId,
          coursePhase: this.form.coursePhase,
          courseStatus: this.form.courseStatus,
          isMarket: this.form.isMarket,
          isAchievement: this.form.isAchievement,
          electivesIds: '5,6,7,8',
        };
        if (valid) {
          if (this.operate == 'add') {
            this.http
              .post(`${urlConfig.devUrl}apij2/admin-api/voucher/technology-skill-course-phase/create`, obj)
              .then(res => {
                if (res.code == 0) {
                  this.ResetSearch(['value', 'status']);
                  this.$message.success('新增成功');
                  this.dialogVis = false;
                  // this.getData("Technology_Skill_Course_Phase");
                  this.search();
                } else {
                  this.is_submit = true;
                }
              })
              .catch(err => {
                this.is_submit = true;
              });
          } else {
            obj.id = this.form.id;
            this.http
              .post(`${urlConfig.devUrl}apij2/admin-api/voucher/technology-skill-course-phase/update`, obj)
              .then(res => {
                if (res.code == 0) {
                  this.ResetSearch(['value', 'status']);
                  this.$message.success('编辑成功');
                  this.dialogVis = false;
                  //   this.getData("Technology_Skill_Course_Phase");
                  this.search();
                } else {
                  this.is_submit = true;
                }
              })
              .catch(err => {
                this.is_submit = true;
              });
          }
        } else {
          this.is_submit = true;
        }
      });
    },
    close() {
      this.$refs['form'].resetFields();
      this.dialogVis = false;
    },
    handleCurrentChange(val) {
      this.current_page = val;
      this.getData(
        'Technology_Skill_Course_Phase?page='+val+'&course_id=' + this.value + '&course_status=' + this.status + (this.srelease ? (this.srelease === 1 ? "&is_market=1&is_achievement=1" : (this.srelease === 2 ? "&is_market=1&is_achievement=2" : "&is_market=2&is_achievement=1")) : '')
      );
      // this.getData(`Technology_Skill_Course_Phase?page=${val}`);
    },
    getData(url) {
      let params = {
        page: this.current_page,
        courseId: this.value,
        courseStatus: this.status
      };
      if(this.srelease && this.srelease ===1){
        params.isMarket = 1
        params.isAchievement = 1
      }else if(this.srelease && this.srelease ===2){
        params.isMarket = 1
        params.isAchievement = 2
      }else if(this.srelease){
        params.isMarket = 2
        params.isAchievement = 1
      }

      this.http.post(`${urlConfig.devUrl}apij2/admin-api/voucher/technology-skill-course-phase/page`, params).then(res => {
        if (res.code == 0) {
          this.tableData = res.data.data;
          this.per_page = res.data.per_page;
          this.total = res.data.total;
          this.current_page = res.data.current_page;
        } else {
          this.$message.error('获取数据失败！！');
        }
      });
    },
    getClasses() {
      this.http.post(`${urlConfig.devUrl}apij2/admin-api/voucher/technology-skill-course/page`, {courseType: 1}).then(res => {
        if (res.code == 0) {
          this.options = res.data.data;
        } else {
          this.$message.error('获取数据失败！！');
        }
      });
    },
  },
  mounted() {
    this.getClasses();
    this.getData('Technology_Skill_Course_Phase');
  },
};
</script>

<style lang="scss">
@include component(business-classes) {
  width: 100%;
  height: 100%;

  @include part(header) {
    display: flex;
    justify-content: flex-start;

    @include component(el-input) {
      width: 300px;
    }

    section {
      margin-left: 50px;
    }
  }

  @include part(searchBtn) {
    margin-left: 10px;
    margin-right: 30px;
  }

  @include part(addBtn) {
    margin-left: 30px;
  }

  @include part(table) {
    margin-top: 30px;
  }
}
</style>
